<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
				<div class="row align-items-end mt-0 pagination-body">
					<div class="d-flex  col-12 col-sm-12 col-md-6 col-lg-6 mt-1 mb-1 date-filter">
						<div class=" mr-2">
							<label>From Date</label>
							<input type="date" [(ngModel)]="start_date" class="form-control" (change)="getStartDate($event)">
						</div>
						<div class=" mr-2">
							<label>To Date</label>
							<input [(ngModel)]="end_date" type="date" class="form-control" (change)="getEndDate($event)">
						</div>
					</div>
				  
				  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
					<div class="row-flex">
					  <div class="col-flex-2 mb-1 position-relative">
						<input id="ngx-filter-ref"
						  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
						  type="text" placeholder="Search" #name (keydown.enter)="filterAttendence(searchVal)"
						  [(ngModel)]="searchVal" />
						<button class="btn search-btn glow position-absolute" (click)="filterAttendence(searchVal)">
						  <i class="ft-search text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1">
						<button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
						  Reset
						  <i class="ft-filter text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1"
						*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
						<button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
						  (click)="openModalAddNew(addNew)" placement="top" ngbTooltip="Add New">
						  +
						</button>
					  </div>
					</div>
				  </div>
				  <div class="col-12 mt-1">
					<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Attendence Guideline</button>
				</div>
				</div>
				
				<div class="d-flex  col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1 date-filter">
					<div *ngFor="let item of status_count_data">
						<span  [ngClass]="{'badge bg-light-success':item?.status == 'full-day','badge bg-light-info':item?.status == 'half-day','badge bg-light-danger':item?.status == 'paid-leave','badge bg-light-warning':item?.status == 'unpaid-leave','badge bg-light-primary':item?.status == 'short-leave'}">{{item?.status | titlecase}} </span> &nbsp; : <span class="mr-1"> {{item?.count}}</span>
					</div>
				  </div>
			  </fieldset>
			  <!-- ngx-datatable-filter -->
			  
			  <ngx-datatable  class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
			  [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
			  [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
			  (page)="pageChangeData($event)">
			  <ngx-datatable-column name="Date" prop="attendanceDate" [width]="30">
				<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				  <div class="d-flex align-items-center">
					<div class="cell-line-height cursor-pointer" >
					  <p class="font-medium-1 line-height-1 mb-0">
						{{ mediumDate(row?.attendanceDate) }}
					  </p>
					</div>
				  </div>
				</ng-template>
			  </ngx-datatable-column>
			  <ngx-datatable-column name="Start Time" prop="startTime" [width]="10">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="cell-line-height">
					 {{row?.startTime | convertTo12Hour }}
					</div>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="End Time" prop="endTime" [width]="10">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="cell-line-height">
					 {{row?.endTime | convertTo12Hour }}
					</div>
				  </ng-template>
				</ngx-datatable-column>
			  <ngx-datatable-column name="Working Hours" prop="workingHours" [width]="10">
				<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				  <div class="cell-line-height">
				   {{row?.workingHours}}
				  </div>
				</ng-template>
			  </ngx-datatable-column>
			  
			  <ngx-datatable-column name="Status" prop="status" [width]="30">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="cell-line-height">
					 <p *ngIf="row?.status?.displayname == 'Full-Day'" [ngClass]="{'badge badge-pill bg-light-success':row?.status?.displayname == 'Full-Day'}">{{row?.status?.displayname}}</p>

					 <p *ngIf="row?.status?.displayname == 'Paid Leave'" [ngClass]="{'badge badge-pill bg-light-danger':row?.status?.displayname == 'Paid Leave'}">{{row?.status?.displayname}}</p>

					 <p *ngIf="row?.status?.displayname == 'Unpaid Leave'" [ngClass]="{'badge-pill bg-light-warning':row?.status?.displayname == 'Unpaid Leave'}">{{row?.status?.displayname}}</p>

					 <p *ngIf="row?.status?.displayname == 'Half-Day'" [ngClass]="{'badge-pill bg-light-info':row?.status?.displayname == 'Half-Day'}">{{row?.status?.displayname}}</p>

					 <p *ngIf="row?.status?.displayname == 'Short-Leave'" [ngClass]="{'badge-pill bg-light-primary':row?.status?.displayname == 'Short-Leave'}">{{row?.status?.displayname}}</p>
					</div>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Verified" prop="isVerified" [width]="10">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					  <p >
						  <span *ngIf="row?.isVerified == 'yes'"
						  [ngClass]="{'bg-light-success badge badge-pill':row?.isVerified == 'yes'}">
						  {{row?.isVerified}}
						</span>
						<span *ngIf="row?.isVerified == 'inreview'"
						  [ngClass]="{'bg-light-warning badge badge-pill':row?.isVerified == 'inreview'}">
						  in review
						</span>
						<span *ngIf="row?.isVerified == 'no'"
						  [ngClass]="{'bg-light-danger badge badge-pill':row?.isVerified == 'no'}">
						  {{row?.isVerified}}
						</span>
					  </p>
					</ng-template>
				</ngx-datatable-column>
			  <ngx-datatable-column name="Action" prop="isVerified" [width]="60">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<!-- <div class="custom-switch custom-control-inline mb-1 mb-xl-0">
					  <mat-slide-toggle color="primary" [checked]="row?.isVerified"
						></mat-slide-toggle>
					</div> -->
					<span class="mr-2" placement="left" ngbTooltip="Check Task and Notes to HR " (click)="openModal2(myModal2,row)"> <i class="ft-eye text-primary cursor-pointer"></i></span>
					<button *ngIf="row?.isVerified == 'inreview'" class="btn btn-primary" ><span >In Review</span></button>
					<button *ngIf="row?.isVerified == 'no' || row?.isVerified == 'yes'" [disabled]="row?.isVerified == 'yes'" class="btn btn-primary" (click)="verifyAttendence(row?._id)">Request Review</button>
					<!-- <span class="cursor-pointer"><i class="ft-aperture text-primary" (click)="verifyAttendence(row?._id)"></i></span> -->
				  </ng-template>
				</ngx-datatable-column>
			  
			</ngx-datatable>
		 
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>

<!------  Add Attendence Popup -------------------------->

<div>
	<ng-template #addNew let-modal>
	  <div class="modal-header">
		<h4 class="modal-title">Add Attendence</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<form [formGroup]="attendenceForm">
			<fieldset class="form-group">
				<label>Attendance Date</label>
				<input
				  type="date"
				  class="form-control"
				  formControlName="attendanceDate"
				  [ngModel]="model.attendanceDate | date: 'yyyy-MM-dd'"
				  [max]="maxDate"
				  [min]="minDate"
				  [disabled]="false"
				  id="attendanceDate"
				/>
			</fieldset>
			<fieldset class="form-group">
			  <label>Start Time</label>
			  <input
				type="time"
				class="form-control"
				[formControl]="startTime" [(ngModel)]="model.startTime"
				id="startTime"
				placeholder="Enter start time"
				required
			  />
			
			</fieldset>
			<fieldset class="form-group">
				<label>End Time</label>
				<input
				  type="time"
				  class="form-control"
				  [formControl]="endTime" [(ngModel)]="model.endTime"  
				  id="endTime"
				  placeholder="Enter end time" 
				  required
				/>
			</fieldset>
			<fieldset class="form-group">
				<label>Working Hours</label>
				<input
				  type="text"
				  class="form-control"
				  [(ngModel)]="timeDiff" [ngModelOptions]="{standalone: true}"
				  placeholder="Enter Work Hours" readonly
				/>
			</fieldset>

			  <fieldset class="form-group">
				<label>Status</label>
				<ng-select
				  [items]="status_list"
				  bindLabel="displayname"
				  bindValue="_id"
				  [closeOnSelect]="false"
				  placeholder="Select status"
				  [(ngModel)]="selected_status"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getStatusId($event)"
				>
				</ng-select>
			  </fieldset>
			
			  <fieldset class="form-group">
				<label>Task <span class="required_field mr-2">*</span> <span (click)="importTask()"  placement="right" ngbTooltip="Import current task"><i class="ft-arrow-down-circle text-primary font-large cursor-pointer"></i></span></label>
				<textarea
				  formControlName="task" [(ngModel)]="model.task"
				  id="tasktext"
				  rows="3"
				  class="form-control"
				  name="comment2"
				  placeholder="Enter task (at least 20 characters)"
				  required
				></textarea>
				<div *ngIf="attendenceForm.get('task').hasError('notEnoughCharacters')" class="error-message">
					<small>Task must have at least 20 characters.</small>
				  </div>
			  </fieldset>
			<fieldset class="form-group">
			  <label>Notes to Hr</label>
			  <textarea
				formControlName="notes" [(ngModel)]="model.notes"
				id="hidden-label-form-6"
				rows="3"
				class="form-control"
				name="comment2"
				placeholder="Enter notes"
			  ></textarea>
			</fieldset>
		  </form>
  
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		<button [disabled]="!attendenceForm.get('task').valid" type="button" class="btn btn-primary" (click)="submit()">Submit</button>
	  </div>
	</ng-template>
  </div>

<!-------------- Check Task and Notes to Hr  Popup ------------------------------------------->
<div>
	<ng-template #myModal2 let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Details of Task & Notes to HR</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<table>
				<tr>
					<th>Task :</th>
					<td [innerText]="row_data?.task?row_data?.task:'Data Not Found!'"></td>
				</tr>
				<tr>
					<th>Notes to HR :</th>
					<td [innerText]="row_data?.notes?row_data?.notes : 'Data Not Found!'"></td>
				</tr>
				<tr>
					<th>Admin Notes :</th>
					<td [innerText]="row_data?.admin_notes?row_data?.admin_notes:' Data Not Found!'"></td>
				</tr>
			</table>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		</div>
	</ng-template>
</div>
